













import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {envInstance} from '@/lib/plugins/env'
import {LicenseType} from '@/lib/kepler/interfaces'
import UploadTypeChooser from '@/components/UploadTypeChooser.vue'
import Dropzone from '../lib/dropzone/Dropzone.vue'

declare let device: any

@Component({
  name: 'DocumentImageUpload',
  components: {
    UploadTypeChooser,
    Dropzone,
  },
})
export default class DocumentImageUpload extends Vue {
  @State((state) => state.licenseTypes.licenseTypes) public LicenseTypes!: LicenseType[]
  @Action('openDialog') public openDialog!: any
  @Action('closePopup') public closePopup!: any
  @Action('closeDialog') public closeDialog!: any
  @Prop({}) public view?: string
  @Prop({
    type: Boolean,
    default: false,
  }) public error?: boolean

  public uploadUrl: string = `${envInstance.API_URL}v1/attachment/upload`

  public img: { url: string, token: string, open: boolean } = {url: '', token: '', open: false}

  protected upload() {
    this.$set(this.img, 'open', true)
  }

  protected toggleChooser() {
    this.$set(this.img, 'open', !this.img.open)
  }

  protected setImage(data: any) {
    this.$set(this.img, 'url', data.url)
    this.$set(this.img, 'token', data.token)
    this.$emit('uploaded', data.token, this.view)
  }

  protected uploaded(file: any, response: any) {
    this.$emit('uploaded', response.token, this.view)
  }

  protected DocStyle() {
    return {
      background: `url("${this.img.url || 'img/icons/document.svg'}") center center / 46% no-repeat`,
    }
  }

  protected get isBrowser() {
    return device.platform === 'browser'
  }
}
